import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Svg } from "../../components/Svg";
const SvgArrowBackOutline = (props) => (_jsx(Svg, { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...props, children: _jsx("path", { fill: "currentColor", d: "m7.04 12.75 5.696 5.696-1.07 1.054-7.5-7.5 7.5-7.5 1.07 1.054L7.04 11.25h12.127v1.5z" }) }));
export default SvgArrowBackOutline;
SvgArrowBackOutline.displayName = "SvgArrowBackOutline";
//# sourceMappingURL=ArrowBackOutline.js.map